import React from 'react';
import { observer } from "mobx-react-lite";
import { useTranslation } from 'react-i18next';
import { DynamicMapElementPropertiesEditorTemplate, LabelInput } from './DynamicMapElementPropertiesSharedElements';
export const DynamicMapElementMapMarkerPropertiesEditor = observer(({
  element,
  mapEditorStore
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(DynamicMapElementPropertiesEditorTemplate, {
    element: element,
    mapEditorStore: mapEditorStore,
    elementTypeKey:
    /*t*/
    "editor.editor_display_type_map_marker"
  }, /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement(LabelInput, {
    element: element,
    allElements: mapEditorStore.currentMapStore.currentMap.mapMarkers,
    alreadyUsedWarningLabelKey:
    /*t*/
    "editor.warning_map_marker_label_already_used",
    onChange: value => element.setLabel(value)
  }))));
});